<div class="analytics-container">
  <div class="analytics-header">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Service Intelligence</h2>
      <!-- REMOVED: Old apply filters button - now handled by the reusable filter component -->
    </div>

    <!-- NEW: Replaced complex filter controls with reusable analytics filter component -->
    <app-analytics-filter
      [filterConfig]="filterConfig"
      [selectedTimeRange]="selectedTimeRange()"
      [startDate]="startDate()"
      [endDate]="endDate()"
      [industries]="industries()"
      [selectedIndustries]="selectedIndustries()"
      [selectedOrganizations]="selectedOrganizations()"
      [groupedServices]="groupedServices()"
      [selectedServiceGroups]="selectedServiceGroups()"
      [filteredProductsByService]="filteredProductsByService()"
      [selectedTools]="selectedTools()"
      [orgService]="orgService"
      (onTimeRangeChange)="onTimeRangeChange($event)"
      (onStartDateChange)="onStartDateChange($event)"
      (onEndDateChange)="onEndDateChange($event)"
      (onIndustryChange)="onIndustryChange($event)"
      (onOrganizationsChange)="onOrganizationsChange($event)"
      (onServiceGroupChange)="onServiceGroupChange($event)"
      (onToolsChange)="onToolsChange($event)"
      (onApplyFilters)="onApplyFilters($event)"
      (onResetFilters)="onResetFilters()"
    ></app-analytics-filter>
  </div>

  <!-- Debug info -->
  @if (false) {
  <div>
    <h3>Debug: Partner Ticket Trends</h3>
    <pre>{{ ticketTrends | json }}</pre>
  </div>
  }

  <app-distillation-funnel
    [ticketTrends]="ticketTrends()"
    [AlertStatSummary]="alertStatSummary()"
    [organizationId]="organizationId()"
    [startDate]="startDateString"
    [endDate]="endDateString"
    [queryType]="queryType()"
    [selectedOrgIds]="filteredOrgIds()"
    [securityTool]="getSecurityToolsParameter()"
    [isLoading]="isFunnelDataLoading()"
  ></app-distillation-funnel>

  <!-- Key Performance Metrics -->
  <div class="dashboard-metrics">
    <app-customers-card
      [partnerOrgCount]="partnerOrgCount()"
      [organizationId]="organizationId()"
      [startDate]="startDateString"
      [endDate]="endDateString"
      [queryType]="queryType()"
      [selectedOrgIds]="filteredOrgIds()"
    ></app-customers-card>

    <app-sla-adherence-card
      [slaAdherenceV2]="slaAdherence()"
      [organizationId]="organizationId()"
      [filteredOrgIds]="filteredOrgIds()"
      [startDate]="startDateString"
      [endDate]="endDateString"
      [queryType]="queryType()"
      [selectedOrgIds]="filteredOrgIds()"
    ></app-sla-adherence-card>

    <app-mttd-card
      [partnerMttd]="partnerMttd()"
      [organizationId]="organizationId()"
      [startDate]="startDateString"
      [endDate]="endDateString"
      [queryType]="queryType()"
      [selectedOrgIds]="filteredOrgIds()"
    ></app-mttd-card>

    <app-mttr-card
      [averageMttr]="averageMttr()"
      [organizationId]="organizationId()"
      [startDate]="startDateString"
      [endDate]="endDateString"
      [queryType]="queryType()"
      [selectedOrgIds]="filteredOrgIds()"
    ></app-mttr-card>
  </div>

  <!-- Outcome Status Components -->
  <div class="dashboard-charts">
    <div class="tile chart-container">
      <div class="tile-title">
        <div style="display: flex; align-items: center; justify-content: space-between">
          <div style="flex: 1; display: flex; justify-content: center">
            <h2>
              Escalation Outcomes
              <span
                kendoTooltip
                tooltipClass="custom-tooltip"
                title="Indication of whether the escalation was important to you (True Positive) or not (False Positive). 'Unknown' indicates no response was received from you or your team."
              >
                <kendo-svg-icon [icon]="infoCircleIcon"></kendo-svg-icon>
              </span>
            </h2>
          </div>
          <kendo-dropdownbutton
            #adrmanualMoreButton
            kendoButton
            fillMode="flat"
            size="small"
            [svgIcon]="moreVerticalIcon"
            [data]="[{ text: 'View Data', name: 'escalationoutcomes' }]"
            (itemClick)="onContextMenuSelect($event)"
          ></kendo-dropdownbutton>
        </div>
      </div>
      <app-outcome-status
        [data]="outcomeStatusData()"
        [organizationId]="organizationId()"
        [startDate]="startDateString"
        [endDate]="endDateString"
        [queryType]="queryType()"
        [selectedOrgIds]="filteredOrgIds()"
      ></app-outcome-status>
    </div>
    <div class="chart-container">
      <h2>Unknown Ticket Overview</h2>
      <app-unknown-tickets-chart
        [topTicketInfo]="topTicketInfo()"
        [unknownRateData]="unknownRateData()"
      ></app-unknown-tickets-chart>
    </div>
  </div>
</div>
